"use client";

import { useEffect } from "react";

import { renderDiagram, type DiagramKind } from "@/lib/diagram-render";

function decodeBase64Utf8(b64: string): string {
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

const KINDS: { kind: DiagramKind; attr: string }[] = [
  { kind: "graphviz", attr: "data-graphviz" },
  { kind: "abc", attr: "data-abc" },
  { kind: "echarts", attr: "data-echarts" },
];

export default function DiagramRuntime() {
  useEffect(() => {
    let cancelled = false;

    for (const { kind, attr } of KINDS) {
      const nodes = Array.from(
        document.querySelectorAll<HTMLElement>(`div.${kind}[${attr}]`),
      );
      for (const el of nodes) {
        const encoded = el.getAttribute(attr);
        if (!encoded) continue;
        const source = decodeBase64Utf8(encoded);
        el.removeAttribute(attr);
        void renderDiagram(kind, source, el).catch(() => {
          if (!cancelled) el.textContent = source;
        });
      }
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
